import NodeCache from "node-cache";
const cache = new NodeCache({ stdTTL: 300, checkperiod: 320 });
// components
import ProductDetail from "@/components/ProductDetail/ProductDetail";
import Inventory from "@/components/Inventory/Inventory";

// lib
import { fetchPageData } from "../../lib/fetchPageData";
import { generateDataLayer } from "../../utils/dataLayerUtils";

const DynamicPage = ({ type, Item, dataLayer }) => {
  return (
    <div>
      {type === "category" && (
        <div>
          {Item && Item.initialData && (
            <Inventory initialData={Item.initialData} />
          )}
        </div>
      )}
      {type === "productPage" && (
        <div>
          {Item.item && <ProductDetail Item={Item} dataLayer={dataLayer} />}
        </div>
      )}
      {!type && <div>404 - Page Not Found</div>}
    </div>
  );
};

export async function getServerSideProps(context) {
  const { industry, slug } = context.query;
  const categoryOrProduct = slug ? slug[0] || null : null;
  let type = "";

  if (categoryOrProduct) {
    const id = categoryOrProduct.split("-").pop();

    if (id && Number(id) > 0) {
      type = "productPage";
      const newInd = industry;
      const cacheKey = `item_${id}`;
      try {
        let data = cache.get(cacheKey);
        if (!data) {
          const res = await fetch(
            `${process.env.BASE_URL}GetItemImagesAsync/${id}`
          );
          if (res.status === 400 || res.status === 404) {
            throw new Error("Item not found");
          }
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          data = await res.json();

          cache.set(cacheKey, data);
        } else {
        }
        const sortedImgData = data.images;
        const altTaggedImages = sortedImgData.map((image, index) => ({
          ...image,
          originalAlt: data.item.description || `Slider ${index + 1}`,
          thumbnailAlt: data.item.description || `Slider ${index + 1}`,
          originalWidth: 524,
          originalHeight: 568,
          thumbnailWidth: 50,
          thumbnailHeight: 60,
          loading: "high",
          sizes: "(max-width: 480px) 100vw, 480px",
        }));
        data = { ...data, images: altTaggedImages, industry1: newInd };
        const dataLayer = generateDataLayer(data.item);

        return {
          props: {
            type: type,
            Item: data,
            dataLayer,
            industry: newInd,
          },
        };
      } catch (error) {
        return {
          redirect: {
            type: type,
            destination: "/404",
            permanent: true,
          },
          props: {
            type: type,
            Item: null,
            dataLayer: null,
            industry1: newInd,
          },
        };
      }
    } else {
      type = "category";
      const data = await fetchPageData(context);
      return {
        props: {
          type: type,
          Item: data,
          dataLayer: null,
          industry: null,
        },
      };
    }
  }

  return {
    props: {
      type: type,
      Item: null,
      dataLayer: null,
      industry1: null,
    },
  };
}

export default DynamicPage;
